import Swiper from 'swiper/bundle';
// This setTimeout is for when testing static hosted via vite
// setTimeout(() => {

function updateBackgroundImage(slide) {
	let heroImageElement;

	if (slide.classList.contains('hero-image')) {
		heroImageElement = slide;
	} else {
		heroImageElement = slide.querySelector('.hero-image');
	}

	if (heroImageElement && slide.querySelector('picture')) {
		const picture = slide.querySelector('picture');
		const sources = picture.querySelectorAll('source');
		let selectedImage;

		sources.forEach(source => {
			if (window.matchMedia(source.media).matches) {
				selectedImage = source.srcset;
			}
		});

		if (selectedImage) {
			const currentBackgroundImage = heroImageElement.style.backgroundImage;
			const newBackgroundImage = `url("${selectedImage}")`;

			if (currentBackgroundImage !== newBackgroundImage) {
				heroImageElement.style.backgroundImage = newBackgroundImage;
			}
		}
	}
}

// Hero Carousel
if (document.querySelector('.hero-carousel') && document.querySelectorAll('.hero-carousel .swiper-slide').length > 1) {
	const heroCarousel = new Swiper('.hero-carousel', {
		navigation: {
			nextEl: '.hero-carousel .swiper-button-next',
			prevEl: '.hero-carousel .swiper-button-prev',
		},
		pagination: {
			el: '.hero-carousel .swiper-pagination',
			clickable: true,
		},
		autoplay: {
			delay: 5000,
		},
		mousewheel: {
			forceToAxis: true,
		},
		speed: 800,
		slidesPerView: 1,
		loop: true
	});
	const pauseButton = document.querySelector('.swiper-button-pause');
	const playButton = document.querySelector('.swiper-button-play');

	pauseButton.addEventListener('click', function(e) {
		this.classList.toggle('sr-only');
		playButton.classList.toggle('sr-only');
		heroCarousel.autoplay.stop();
	});

	playButton.addEventListener('click', function(e) {
		this.classList.toggle('sr-only');
		pauseButton.classList.toggle('sr-only');
		heroCarousel.autoplay.start();
	});

// Initialize Swiper events
	function handleCarouselEvents(carousel) {
		const updateActiveSlideBackground = () => {
			const activeSlide = carousel.slides[carousel.activeIndex];
			updateBackgroundImage(activeSlide);
		};

		carousel.on('init', updateActiveSlideBackground);
		carousel.on('slideChange', updateActiveSlideBackground);

		window.addEventListener('resize', updateActiveSlideBackground);
	}

	if (Array.isArray(heroCarousel)) {
		heroCarousel.forEach(handleCarouselEvents);
	} else {
		handleCarouselEvents(heroCarousel);
	}
}
if (document.querySelector('.hero.hero-alt')) {
	document.querySelectorAll('.hero.hero-alt .hero-image').forEach(element => {
		updateBackgroundImage(element);
	});
	window.addEventListener('resize', () => {
		document.querySelectorAll('.hero.hero-alt .hero-image').forEach(element => {
			updateBackgroundImage(element);
		});
	});
}

// Category Carousel
if (document.querySelector('.category-carousel')) {
	const categoryCarousel = new Swiper('.category-carousel', {
		scrollbar: {
			el: '.category-carousel .swiper-scrollbar',
			draggable: true,
			hide: false,
			dragSize: 165
		},
		mousewheel: {
			releaseOnEdges: true,
			forceToAxis: true,
		},
		slidesPerView: 'auto',
		centeredSlides: false
	});
}

// Category Carousel
if (document.querySelector('.category-carousel--mobile')) {
	const mobileCategoryCarousel = new Swiper('.category-carousel--mobile', {
		navigation: {
			nextEl: '.category-carousel--mobile .swiper-button-next',
			prevEl: '.category-carousel--mobile .swiper-button-prev',
		},
		mousewheel: {
			forceToAxis: true,
		},
		slidesPerView: 'auto',
		centeredSlides: false,
		on: {
			afterInit: function() {
				scrollToSelectedPill(this);
			}
		}
	});
}

function scrollToSelectedPill(swiper) {
	swiper.slides.some(slide => {
		if (slide.classList.contains('selected') && slide.getAttribute('id')) {
			swiper.slideTo(slide.getAttribute('id').split('-')[1], 300, false);
			return true;
		}
	});
}

//Feature Content Carousel
if (document.querySelector('.featured-content-carousel')) {
	const featuredCarousel = new Swiper('.featured-content-carousel', {
		navigation: {
			nextEl: '.featured-content-carousel .swiper-button-next',
			prevEl: '.featured-content-carousel .swiper-button-prev',
		},
		pagination: {
			el: '.featured-content-carousel .swiper-pagination',
			clickable: true,
		},
		mousewheel: {
			forceToAxis: true,
		},
		speed: 800,
		loop: true,
		slidesPerView: 1,
		centeredSlides: true,
		breakpoints: {
			300: {
				slidesPerView: 1
			},
			1024: {
				slidesPerView: 1.2
			},
			1100: {
				slidesPerView: 1.35
			},
			1200: {
				slidesPerView: 1.5
			}
		}
	});
}

// Story Card Carousel
if (document.querySelector('.story-carousel')) {
	const storyCarousel = new Swiper('.story-carousel', {
		scrollbar: {
			el: '.story-carousel .swiper-scrollbar',
			draggable: true,
			hide: false,
			dragSize: 165
		},
		mousewheel: {
			releaseOnEdges: true,
			forceToAxis: true,
		},
		spaceBetween: 20,
		slidesPerView: 'auto',
		centeredSlides: false
	});
}

let contentSliders = document.querySelectorAll('.content-slider');
if (contentSliders.length > 0) {
	const contentCarousel = new Swiper('.content-slider', {
		navigation: {
			nextEl: '.content-slider .swiper-button-next',
			prevEl: '.content-slider .swiper-button-prev',
		},
		pagination: {
			el: '.content-slider .swiper-pagination',
			clickable: true,
		},
		mousewheel: {
			forceToAxis: true,
		},
		speed: 800,
		loop: true,
		lazy: true,
		lazyPreloadPrevNext: 2,
		autoHeight: true,
		slidesPerView: 1.3,
		spaceBetween: 20,
		centeredSlides: false,
		loopedSlides: 3,
		freeMode: {
			enabled: true,
			momentumRatio: 0.6,
			momentumVelocityRatio: 1,
			momentum: true,
			sticky: true
		},
		breakpoints: {
			592: {
				slidesPerView: 2,
				freeMode: false
			},
			1024: {
				slidesPerView: 3
			}
		}
	});

	contentSliders.forEach(slider => {
		slider.classList.remove('swiper-loading');
		slider.swiper.updateAutoHeight();
		const controlsEl = slider.querySelector('.content-slider-controls');
		const testImageHeight = slider.querySelector('img').height;
		const iconHeightOffset = 36;
		if (controlsEl && testImageHeight) {
			controlsEl.style.top = `${ (testImageHeight / 2) + (iconHeightOffset / 2) - 12 }px`;
		}
	});

	document.querySelectorAll('.content-slider--disable').forEach(slider => {
		const mediaQuery = window.matchMedia('(max-width: 592px)');
		if (mediaQuery.matches) { return; }
		slider.swiper.disable();
	});
}



// Story Card Carousel Mobile Adaptive Version
if (document.querySelector('.story-carousel--mobile')) {
	const storyCarousel = new Swiper('.story-carousel--mobile', {
		navigation: {
			nextEl: '.story-carousel--mobile .swiper-button-next',
			prevEl: '.story-carousel--mobile .swiper-button-prev',
		},
		mousewheel: {
			forceToAxis: true,
		},
		spaceBetween: 20,
		slidesPerView: 1,
		centeredSlides: false,
		breakpoints: {
			680: {
				slidesPerView: 2,
				spaceBetween: 20,
				centeredSlides: false
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
				centeredSlides: false
			},
		}
	});
}

// Insta Carousel
if (document.querySelector('.insta-carousel')) {
	const instaCarousel = new Swiper('.insta-carousel', {
		scrollbar: {
			el: '.insta-carousel .swiper-scrollbar',
			draggable: true,
			hide: false,
			dragSize: 165
		},
		mousewheel: {
			releaseOnEdges: true,
			forceToAxis: true,
		},
		spaceBetween: 20,
		slidesPerView: 'auto',
		centeredSlides: false
	});
}
// Insta Carousel Mobile Adaptive Version
if (document.querySelector('.insta-carousel--mobile')) {
	const instaCarousel = new Swiper('.insta-carousel--mobile', {
		navigation: {
			nextEl: '.insta-carousel--mobile .swiper-button-next',
			prevEl: '.insta-carousel--mobile .swiper-button-prev',
		},
		mousewheel: {
			releaseOnEdges: true,
			forceToAxis: true,
		},
		spaceBetween: 20,
		slidesPerView: 'auto',
		centeredSlides: false
	});
}
//Below is the closing for the setTimeout
// }, 1000);